import api from '../services/api'

export default ({ app, router, store, Vue }) => {
  Vue.prototype.$api = api
}
